import $ from 'jquery';

const WarehouseShow = {
  bindToCountryEdit() {
    $(`#country-edit`).click((e) => {
      e.preventDefault();
      $(`#country-form`).toggleClass(`hide`);
      $(`#country-display`).toggleClass(`hide`);
      const text = $(e.target).text();
      $(e.target).text(text === `Edit` ? `Cancel` : `Edit`);
    });
  },

  bindToPage() {
    this.bindToCountryEdit();
  },

  init() {
    if ($(`#warehouse-show`).length === 0) {
      return;
    }
    this.bindToPage();
  },
};

export default WarehouseShow;
